import React from "react";
import { ShieldCheck, ShieldAlert, ShieldX, Shield } from "lucide-react";

const fmt = (iso) => { try { return new Date(iso).toLocaleDateString(undefined, { dateStyle: "medium" }); } catch { return iso; } };

// Chip summarising an OEM's authorisation-letter status.
export default function AuthStatusChip({ auth, testid = "auth-status" }) {
  const status = auth?.status || "none";
  const earliest = auth?.earliest;
  const map = {
    valid: { cls: "bg-emerald-100 text-emerald-700", Icon: ShieldCheck, label: earliest ? `Authorised · expires ${fmt(earliest)}` : "Authorised" },
    expiring: { cls: "bg-amber-100 text-amber-700", Icon: ShieldAlert, label: `Authorisation expiring ${fmt(earliest)}` },
    expired: { cls: "bg-rose-100 text-rose-700", Icon: ShieldX, label: `Authorisation expired ${fmt(earliest)}` },
    none: { cls: "bg-slate-100 text-slate-500", Icon: Shield, label: "No authorisation letter" },
  };
  const { cls, Icon, label } = map[status] || map.none;
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium ${cls}`} data-testid={`${testid}-${status}`}>
      <Icon className="h-3.5 w-3.5" />{label}
    </span>
  );
}
